export default __webpack_public_path__ + "static/media/RidmaSirimanna.2160ff84.jpeg";